import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "preview"]

  highlight(event) {
    event.preventDefault()
    event.stopPropagation()
    event.dataTransfer.dropEffect = 'copy'
    this.element.classList.add('bg-light', 'border-success')
  }

  unhighlight(event) {
    event.preventDefault()
    event.stopPropagation()
    this.element.classList.remove('bg-light', 'border-success')
  }

  handleDrop(event) {
    event.preventDefault()
    event.stopPropagation()
    this.unhighlight(event)
    
    const files = event.dataTransfer.files
    if (files.length > 0) {
      this.inputTarget.files = files
      this.updatePreview(files[0])
    }
  }

  handleFileSelect(event) {
    const file = event.target.files[0]
    if (file) {
      this.updatePreview(file)
    }
  }

  updatePreview(file) {
    this.previewTarget.innerHTML = `
      <div class="alert alert-success alert-dismissible fade show mt-2" role="alert">
        <i class="fas fa-file-pdf me-2"></i>
        <strong>${file.name}</strong> (${(file.size / 1024 / 1024).toFixed(2)} MB)
        <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
      </div>
    `
  }
}
